<template>
  <div class="mt-16">
    <v-row
      style="border-bottom: 1px solid #737373; width: 100%; padding-bottom: 6px;"
    >
      <h3>{{ heading }}</h3>
    </v-row>

    <v-row class="mt-12">
      <div v-for="test in tests" :key="test.name" class="mr-4 mb-6">
        <!-- Tests that are not supported by selected sample type and display support label in tooltip -->
        <v-tooltip v-if="isValidForInteraction(test.name)" bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <v-btn
                depressed
                :id="`${test.name}_${topic}_add`"
                :class="
                  selectedTests.includes(test.name)
                    ? 'selected-test-btn'
                    : 'test-btn'
                "
                disabled
                @click="updateSelected(test.name)"
              >
                {{ test.testName }}
              </v-btn>
            </span>
          </template>
          <span> {{ getSampleSupportLabel(test.name) }}</span>
        </v-tooltip>
        <!-- Tests that are supported by selected sample type and display assistance notes  -->
        <v-tooltip
          v-else-if="
            !isValidForInteraction(test.name) &&
              isTestWithAssistanceNotes(test.name)
          "
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <v-btn
                depressed
                :id="`${test.name}_${topic}_add`"
                :class="
                  selectedTests.includes(test.name)
                    ? 'selected-test-btn'
                    : 'test-btn'
                "
                @click="updateSelected(test.name)"
              >
                {{ test.testName }}
              </v-btn>
            </span>
          </template>
          <span> {{ getAssistanceNotes(test.name) }}</span>
        </v-tooltip>
        <v-btn
          v-else
          depressed
          :id="`${test.name}_${topic}_add`"
          :class="
            selectedTests.includes(test.name) ? 'selected-test-btn' : 'test-btn'
          "
          @click="updateSelected(test.name)"
        >
          {{ test.testName }}
        </v-btn>
      </div>
    </v-row>
  </div>
</template>

<script>
import DropDownMixin from "../mixins/DropDownMixin.vue";
import { useSectionStore } from "../store/SectionStore";
import { EventBus } from "../event-bus";

export default {
  mixins: [DropDownMixin],
  props: {
    isValidForInteraction: Function,
    tests: Array,
    selectedTests: Array,
    heading: String,
    getSampleSupportLabel: Function,
    topic: String,
  },
  setup() {
    const store = useSectionStore();
    return {
      store,
    };
  },
  data: () => ({
    testsWithAssistanceNotes: ["variant_detection", "childhood_syndromes"],
    testsWithAssistanceNotesContent: [
      {
        name: "variant_detection",
        assistantNotes: "Includes Medicare-funded cascade testing in relatives",
      },
      {
        name: "childhood_syndromes",
        assistantNotes:
          "If all required samples received are EDTA blood, testing will proceed via Whole Genome Sequencing.",
      },
    ],
  }),
  methods: {
    updateSelected(testName) {
      EventBus.$emit("updateSelectedTests", testName);
    },
    isTestWithAssistanceNotes(testName) {
      return this.testsWithAssistanceNotes.includes(testName);
    },
    getAssistanceNotes(testName) {
      const targetedTest = this.testsWithAssistanceNotesContent.find(
        (test) => test.name === testName,
      );

      return targetedTest ? targetedTest.assistantNotes : undefined;
    },
  },
};
</script>

<style scoped>
.test-btn {
  border: 1px solid #00538b;
  background: #fff !important;
}

.selected-test-btn {
  background: #00538b !important;
  color: #fff !important;
}
</style>
